import getDropdownId from '@/state/selectors/navigation/get-dropdown-id';
import { IStore } from '@/state/slices/typings';
import NaasHelper from '@/utils/naas-helper';
import { NaasEvent } from '@/utils/naas-helper/enum';

const handleRetailersDropdownOpen = (prevState: IStore, nextState: IStore) => {
	const prevDropdownId = getDropdownId(prevState);
	const dropdownId = getDropdownId(nextState);

	if (prevDropdownId !== 'retailers' && dropdownId === 'retailers') {
		NaasHelper.dispatchEvent(NaasEvent.RETAILER_OVERLAY_OPEN);
	}
};

export default handleRetailersDropdownOpen;
